export const selectAlternativesFromRecommendations = (recommendations, heroDomain, heroSld, maxResults, getSld) => recommendations.filter(_ref => {
  let domain = _ref.domain;
  return domain && domain !== heroDomain && getSld(domain) === heroSld;
}).slice(0, maxResults);
//# sourceMappingURL=TldAlternativesWithPrice.utils.js.map